module.exports = __webpack_public_path__ + "img/6.eb03ac99.gif";